import { render, staticRenderFns } from "./axis-scale-settings.component.vue?vue&type=template&id=57a5a010&scoped=true&"
import script from "./axis-scale-settings.component.vue?vue&type=script&lang=ts&"
export * from "./axis-scale-settings.component.vue?vue&type=script&lang=ts&"
import style0 from "./axis-scale-settings.component.vue?vue&type=style&index=0&id=57a5a010&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5a010",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
